module.exports = __webpack_public_path__ + "img/ch66.57c4246e.png";